import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IGridComponent) {
    (function(GridDensity) {
        GridDensity["GRID_DENSITY_UNKNOWN"] = "GRID_DENSITY_UNKNOWN";
        /**
     * @deprecated
     */ GridDensity["FLEXIBLE"] = "FLEXIBLE";
        /**
     * Tiles per row given viewport: 3 -> 5 -> 8
     * @deprecated
     */ GridDensity["DENSE"] = "DENSE";
        /**
     * Tiles per row given viewport: 2 -> 4 -> 6
     * @deprecated
     */ GridDensity["STANDARD"] = "STANDARD";
        /**
     * Tiles per row given viewport: 1 -> 2 -> 3
     * @deprecated
     */ GridDensity["SPARSE"] = "SPARSE";
    })(IGridComponent.GridDensity || (IGridComponent.GridDensity = {}));
    (function(IColumnLayout) {
        IColumnLayout.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IGridComponent.IColumnLayout || (IGridComponent.IColumnLayout = {}));
    (function(IFixedColumnLayout) {
        IFixedColumnLayout.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IGridComponent.IFixedColumnLayout || (IGridComponent.IFixedColumnLayout = {}));
    (function(IResponsiveTruncationBehaviour) {
        IResponsiveTruncationBehaviour.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IGridComponent.IResponsiveTruncationBehaviour || (IGridComponent.IResponsiveTruncationBehaviour = {}));
    (function(ITruncationBehaviour) {
        ITruncationBehaviour.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IGridComponent.ITruncationBehaviour || (IGridComponent.ITruncationBehaviour = {}));
    (function(IClippedTruncationBehaviour) {
        IClippedTruncationBehaviour.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IGridComponent.IClippedTruncationBehaviour || (IGridComponent.IClippedTruncationBehaviour = {}));
    (function(IExpandTruncationBehaviour) {
        IExpandTruncationBehaviour.build = function(partial) {
            return _object_spread({
                on_click: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IGridComponent.IExpandTruncationBehaviour || (IGridComponent.IExpandTruncationBehaviour = {}));
    (function(ILogTileBatchView) {
        ILogTileBatchView.build = function(partial) {
            return _object_spread({
                parameters: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IGridComponent.ILogTileBatchView || (IGridComponent.ILogTileBatchView = {}));
    IGridComponent.build = function(partial) {
        return _object_spread({
            tiles: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IGridComponent || (IGridComponent = {}));
export var IGridComponent;
